import Scrollhistorie from '@nrk/dh-basis-scrollhistorie'
import { closest } from '@nrk/dh-basis-common'
import altStyles from './cards/alt-text.module.css'
import { IsScrollingMixin } from './is-scrolling-mixin.ts'
import { ScrollProgressMixin } from './scroll-progress-mixin.ts'

export class HistorieScroll extends ScrollProgressMixin(IsScrollingMixin(Scrollhistorie)) {
  connectedCallback() {
    super.connectedCallback()
    this.addEventListener('focus', this.#handleFocus, true)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListener('focus', this.#handleFocus, true)
  }

  /**
   * Handles focus on a background element.
   * Scrolls the corresponding text card into view so that the background element can be seen together with the text.
   */
  #handleFocus = (e) => {
    const backgroundElement = closest(e.target, '[data-background-id]')
    const altTextElement = e.target && closest(e.target, `.${altStyles.altText}`)
    let triggerElement: HTMLElement
    if (backgroundElement) {
      const backgroundId = backgroundElement.getAttribute('data-background-id')
      if (this.activeBackgroundId !== backgroundId) {
        triggerElement = this.triggerElements.find(
          (elm) => elm.getAttribute('data-show-background') === backgroundId,
        )
      }
    } else if (altTextElement) {
      triggerElement = altTextElement.nextElementSibling
    }

    if (triggerElement && triggerElement.getAttribute('data-state') !== 'ACTIVE') {
      triggerElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
